import { render } from "./workflow_notifications.html?vue&type=template&id=760101be&external"
import script from "./workflow_notifications.js?vue&type=script&lang=js&external"
export * from "./workflow_notifications.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__